var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79592 0.704103L10.2959 8.2041C10.4008 8.30862 10.484 8.43281 10.5408 8.56956C10.5976 8.7063 10.6268 8.85291 10.6268 9.00098C10.6268 9.14904 10.5976 9.29565 10.5408 9.4324C10.484 9.56915 10.4008 9.69334 10.2959 9.79785L2.79592 17.2979C2.58457 17.5092 2.29793 17.6279 1.99904 17.6279C1.70016 17.6279 1.41351 17.5092 1.20217 17.2979C0.990824 17.0865 0.872092 16.7999 0.872092 16.501C0.872092 16.2021 0.990824 15.9154 1.20217 15.7041L7.90623 9.00004L1.20123 2.29598C0.989888 2.08463 0.871155 1.79799 0.871155 1.4991C0.871155 1.20022 0.989888 0.913574 1.20123 0.702229C1.41258 0.490885 1.69922 0.37215 1.99811 0.37215C2.29699 0.37215 2.58364 0.490885 2.79498 0.702229L2.79592 0.704103Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.82cac876f38b2a5ab63bbd783a386d15.svg";
export { ForwardRef as ReactComponent };